import React, { useEffect, useState } from 'react';
import { Spinner, ProgressBar } from 'react-bootstrap';

const phrases = [
  "Just gathering today's news!",
  "Translating headlines...",
  "Almost ready!",
  "Finding the best stories...",
  "Checking for new puzzles...",
  "Warming up your language skills!"
];

/**
 * @param {object} props
 * @param {number} [props.duration=3000] — fake progress duration when showProgressBar is true
 * @param {string} [props.headline] — primary line (e.g. retrieval vs. preparing tabs)
 * @param {boolean} [props.showProgressBar=true] — set false for open-ended loads (Firestore / News API)
 */
const LoadingScreen = ({ duration = 3000, headline, showProgressBar = true }) => {
  const [phraseIdx, setPhraseIdx] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const phraseInterval = setInterval(() => {
      setPhraseIdx((idx) => (idx + 1) % phrases.length);
    }, 1800);
    return () => clearInterval(phraseInterval);
  }, []);

  useEffect(() => {
    if (!showProgressBar) return undefined;
    let start;
    let frame;
    function animate(ts) {
      if (!start) start = ts;
      const elapsed = ts - start;
      const percent = Math.min(100, (elapsed / duration) * 100);
      setProgress(percent);
      if (percent < 100) {
        frame = requestAnimationFrame(animate);
      }
    }
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [duration, showProgressBar]);

  const primary = headline ?? phrases[phraseIdx];
  const secondary = phrases[phraseIdx];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        width: '100%',
      }}
    >
      <Spinner animation="border" role="status" aria-label="Loading" style={{ width: 60, height: 60, marginBottom: 24 }} />
      <div style={{ fontSize: 20, fontWeight: 600, marginBottom: headline ? 8 : 16, minHeight: 28, textAlign: 'center', maxWidth: 'min(22rem, 92vw)' }}>
        {primary}
      </div>
      {headline ? (
        <div style={{ fontSize: 15, fontWeight: 400, color: '#555', marginBottom: 16, minHeight: 24, textAlign: 'center', maxWidth: 'min(22rem, 92vw)' }}>
          {secondary}
        </div>
      ) : null}
      {showProgressBar ? (
        <div style={{ width: 240 }}>
          <ProgressBar now={progress} animated style={{ height: 10, borderRadius: 8 }} />
        </div>
      ) : (
        <div style={{ width: 200 }}>
          <ProgressBar now={100} animated striped variant="secondary" style={{ height: 8, borderRadius: 8 }} />
        </div>
      )}
    </div>
  );
};

export default LoadingScreen; 